<template>
  <div class="respons-detail-table">
    <vxe-table
      class="atb-table header-table edit-table border-table disable-ellipsis"
      border="full"
      auto-resize
      resizable
      :data="tableData"
      ref="detailTable"
      :merge-cells="[{ row: 0, col: 0, rowspan: 1, colspan: 4}]"
      :row-class-name="setRowClass"
      :edit-config="{ trigger: 'click', mode: 'row', activeMethod: editActived }"
      @edit-closed="editClosed"
      @edit-actived="activeRow"
      @cell-click="expandRow"
      :edit-rules="validRules"
      :scroll-y="{enabled: false}"
    >
      <vxe-table-column
        width="400"
        field="workItemContent"
        :title="tableDetail.headerTitle"
        :edit-render="{ enabled: isEditable, autofocus: '.el-textarea__inner' }"
      >
        <template #edit="{ row, rowIndex }">
          <template v-if="rowIndex > 0">
            <el-input
              type="textarea"
              :maxlength="$config.input.textareaMaxLength"
              :autosize="{ maxRows: 8 }"
              placeholder="请输入内容"
              v-model="row.workItemContent"
            ></el-input>
          </template>
        </template>
        <template #default="{row, rowIndex}">
          <template v-if="rowIndex === 0">
            <div class="type-add atb-flex atb-flex-justify-between atb-flex-items-center">
              <div>
                <i @click="expandTable" :class="[expandStatus ? 'icon-arrow-up-bold' : 'icon-arrow-down-bold-copy', 'fold']"></i>
                <span @click="expandTable">{{ tableDetail.typeText }}</span>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="atb-flex atb-flex-items-center">
              <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.workItemContent }}</div>
            </div>
          </template>
        </template>
      </vxe-table-column>

      <vxe-table-column
        min-width="200"
        field="yearTarget"
        title="本年度应达标的目标"
        :edit-render="{ enabled: isEditable, autofocus: '.el-textarea__inner' }"
      >
        <template #default="{row}">
          <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.yearTarget }}</div>
        </template>
        <template #edit="{ row }">
          <el-input
            type="textarea"
            :maxlength="$config.input.textareaMaxLength"
            :autosize="{ maxRows: 8 }"
            placeholder="请输入内容"
            v-model="row.yearTarget"
          ></el-input>
        </template>
      </vxe-table-column>
      <vxe-table-column
        width="220"
        field="weight"
        :controls="false"
        :title="`每项职责所占权重(${tableDetail.weight}%)`"
        :edit-render="{ enabled: isEditable, autofocus: '.el-input__inner' }"
      >
        <template #edit="{ row }">
          <el-autocomplete @change="regWeight(row)" v-model.trim="row.weight" :fetch-suggestions="weightSearch"></el-autocomplete>
        </template>
      </vxe-table-column>
      <vxe-table-column field="" title="操作" fixed="right" width="120" class-name="operation" v-if="isEditable">
        <template #default="scope">
          <div v-if="isEditable">
            <el-tooltip class="item" effect="dark" content="保存" placement="bottom">
              <i v-throttle class="icon-baocun" @click.stop="saveEditRow(scope.row, scope.rowIndex)"></i>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
              <i v-throttle class="icon-close delete" @click.stop="deleteTip(scope.row, scope.rowIndex)"></i>
            </el-tooltip>
          </div>
        </template>
      </vxe-table-column>
    </vxe-table>
    <el-dialog title="提示" :visible.sync="showDelTip" width="260px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
        <h2>确定要删除吗</h2>
        <p>此操作会删除对应的工作项</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="del">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showDelTip = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import _ from 'lodash';
export default {
  name: 'DetailTable',
  props: {
    workId: String,
    tableDetail: {
      type: Object,
      default: () => ({})
    },
    isEditable: Boolean,
  },
  data() {
    return {
      mergeCells: [{ row: 0, col: 0, rowspan: 1, colspan: 4}],
      tableData: [{}],
      originTableData: [],
      cloneTableData: [],
      expandStatus: true,
      validRules: {
        workItemContent: [{ required: true, message: `"${this.tableDetail.headerTitle}"为必填项` }],
        yearTarget: [{ required: true, message: '"本年度应达标的目标"为必填项' }],
        weight: [{ required: true, message: '"权重"为必填项' }],
      },

      activedRow: {},
      rowIndex: -1,

      showDelTip: false,
    }
  },
  watch: {
    'tableDetail.tableData': {
      handler(newVal) {
        this.tableData = [{}];
        const tableData = _.cloneDeep(newVal)
        this.tableData.push(...tableData);
        this.originTableData = _.cloneDeep(this.tableData)
      },
      immediate: true,
    },
  },
  methods: {
    newRow() {
      return {
        "id": null,
        "workId": this.workId,
        "workClassify": this.tableDetail.workClassify,
        "workItemNo": '',
        "workItemContent": '',
        "yearTarget": "",
        "weight": null,
      }
    },
    getTableData() {
      return this.tableData.concat(this.cloneTableData).filter(item => item.workId);
    },
    validateTable() {
      return this.$refs.detailTable.validate(this.tableData.filter(item => item.workId)).catch((err) => err);
    },
    refreshTable() {
      this.$refs.detailTable && this.$refs.detailTable.updateData(this.tableData);
    },
    regWeight(row) {
      let reg = new RegExp('^([1-9]|[1-9]\\d|100)$');
      if (!reg.test(row.weight)) {
        if (row.weight - 0 > 100) {
          row.weight = 100;
        } else {
          row.weight = 1;
        }
      }
    },
    weightSearch(queryString, cb) {
      let programList = [{ value: 5 }, { value: 10 }, { value: 15 }, { value: 20 }, { value: 25 }, { value: 30 }];
      // 调用 callback 返回建议列表的数据
      cb(programList);
    },
    setRowClass({ rowIndex }) {
      if (rowIndex == 0) {
        return 'main-row';
      }
    },
    expandTable() {
      this.expandStatus = !this.expandStatus;
      if (this.expandStatus) {
        this.tableData = _.cloneDeep(this.cloneTableData);
        this.cloneTableData = [{}];
      } else {
        this.cloneTableData = _.cloneDeep(this.tableData);
        this.tableData = [{}];
      }
    },
    expandRow({rowIndex}) {
      if(this.$getRowExpandFlag()) this.tableData[rowIndex].expandRowFlag = !this.tableData[rowIndex].expandRowFlag;
      this.refreshTable();
    },
    // 表格显示
    openTable() {
      if (this.expandStatus) return;
      this.expandStatus = true;
      this.tableData = _.cloneDeep(this.cloneTableData);
      this.cloneTableData = [{}];
    },
    // 表格隐藏
    closeTable() {
      if (!this.expandStatus) return;
      this.expandStatus = false;
      this.cloneTableData= _.cloneDeep(this.tableData);
      this.tableData = [{}];
    },
    // 多行文字的数据展开
    openAllRow() {
      this.tableData.concat(this.cloneTableData).filter(item => item.workId).forEach(item => {
        item.expandRowFlag = true;
      });
      this.refreshTable();
    },
    // 多行文字的数据隐藏
    closeAllRow() {
      this.tableData.concat(this.cloneTableData).filter(item => item.workId).forEach(item => {
        item.expandRowFlag = false;
      });
      this.refreshTable();
    },
    editActived({ row, rowIndex }) {
      if (rowIndex === 0) {
        this.$refs.detailTable.clearActived()
      }
      return this.isEditable && rowIndex > 0;
    },
    editClosed({ row, rowIndex }) {
      if (rowIndex == 0) {
        return false;
      }
      if (rowIndex !== -1) {
        row.yearTarget = this.$filterSpecialChars(row.yearTarget);
        row.workItemContent = this.$filterSpecialChars(row.workItemContent);
        if (this.isEditable) {
          if(this.$getRowExpandFlag()) this.tableData[rowIndex].expandRowFlag = false;
          this.refreshTable();
          this.saveEditRow(row, rowIndex);
        }
      }
    },
    activeRow({ row, rowIndex }) {
      if (rowIndex == 0) return false;
      this.activedRow = row;
      this.rowIndex = rowIndex;
    },

    saveEditRow(row, rowIndex) {
      this.originTableData[rowIndex]._X_ID = row._X_ID;
      if (_.isEqual(row, this.originTableData[rowIndex])) {
        return 0;
      }

      this.$confirm('确定要修改吗', '修改', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        closeOnClickModal: false,
        closeOnPressEscape: false,
      }).then(() => {
        this.$emit('save');
        this.originTableData[rowIndex] = _.cloneDeep(row);
      }).catch(() => {
        this.writeRow(this.originTableData[rowIndex], rowIndex);
      }).finally(() => {
        this.$refs.detailTable.clearActived()
      });
    },
    writeRow(row, index) {
      let item = _.cloneDeep(row);
      this.$set(this.tableData, index, item);
    },
    deleteTip(row) {
      this.showDelTip = true;
      this.delRow = row;
    },
    del() {
      if (this.delRow) {
        this.$ajax.get(this.$api.responsWork.manage.deleteResponseDetail, {id: this.delRow.id}).then(() => {
          _.remove(this.tableData, t => t.id == this.delRow.id);
          this.tableData.splice(0, 0);
          this.$message.success('删除成功');
        }).finally(() => {
          this.showDelTip = false;
        });
      }
    },
  },
}
</script>
<style lang="scss" scoped>
  .respons-detail-table {
    ::v-deep .header-table {
      user-select: text;
      .vxe-table--header-wrapper {
        background-color: $--bg-color-complete !important;
      }
      .vxe-table--body-wrapper {
        overflow: visible;
      }
      .main-row {
        .vxe-cell {
          padding: 0;
        }
      }
      .unfinished {
        .vxe-cell{
          color: rgb(254, 107, 104);
        }
      }
      .vxe-table--border-line {
        border-top: none;
      }
    }
    .type-add {
      height: 47px;
      background-color: $--color-bg-table-header;
      color: $--color-primary;
      font-size: 14px;
      padding: 0 15px;
      div {
        cursor: pointer;
        span {
          margin-right: 15px;
        }
        i.fold {
          margin-right: 5px;
        }
      }
      span {
        cursor: pointer;
      }
    }
  }
</style>